// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import { PlasmicOriginalLinkButton, DefaultOriginalLinkButtonProps } from './plasmic/hub_hub/PlasmicOriginalLinkButton';
import { HTMLElementRefOf } from '@plasmicapp/react-web';

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface OriginalLinkButtonProps extends Omit<DefaultOriginalLinkButtonProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultOriginalLinkButtonProps altogether and have
// total control over the props for your component.
export interface OriginalLinkButtonProps extends DefaultOriginalLinkButtonProps {}

function OriginalLinkButton_(props: OriginalLinkButtonProps, ref: HTMLElementRefOf<'div'>) {
  // Use PlasmicOriginalLinkButton to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicOriginalLinkButton are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all OriginalLinkButtonProps here, but feel free
  // to do whatever works for you.

  return <PlasmicOriginalLinkButton originalLinkButton={{ ref }} {...props} />;
}

const OriginalLinkButton = React.forwardRef(OriginalLinkButton_);
export default OriginalLinkButton;
